export default __webpack_public_path__ + "e6869b0b85a27a7fdefebd74df15bbef.svg";